/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeliveryMethodDto } from './DeliveryMethodDto';
import {
    DeliveryMethodDtoFromJSON,
    DeliveryMethodDtoFromJSONTyped,
    DeliveryMethodDtoToJSON,
} from './DeliveryMethodDto';
import type { OSDiscountDto } from './OSDiscountDto';
import {
    OSDiscountDtoFromJSON,
    OSDiscountDtoFromJSONTyped,
    OSDiscountDtoToJSON,
} from './OSDiscountDto';
import type { OpeningHoursDto } from './OpeningHoursDto';
import {
    OpeningHoursDtoFromJSON,
    OpeningHoursDtoFromJSONTyped,
    OpeningHoursDtoToJSON,
} from './OpeningHoursDto';
import type { PaymentMethodDto } from './PaymentMethodDto';
import {
    PaymentMethodDtoFromJSON,
    PaymentMethodDtoFromJSONTyped,
    PaymentMethodDtoToJSON,
} from './PaymentMethodDto';
import type { PlacementDto } from './PlacementDto';
import {
    PlacementDtoFromJSON,
    PlacementDtoFromJSONTyped,
    PlacementDtoToJSON,
} from './PlacementDto';

/**
 * 
 * @export
 * @interface LocationDtoV3
 */
export interface LocationDtoV3 {
    /**
     * 
     * @type {string}
     * @memberof LocationDtoV3
     */
    locationId: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDtoV3
     */
    zoneId: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDtoV3
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof LocationDtoV3
     */
    name: string;
    /**
     * 
     * @type {Array<OpeningHoursDto>}
     * @memberof LocationDtoV3
     */
    openingHours: Array<OpeningHoursDto>;
    /**
     * 
     * @type {Array<DeliveryMethodDto>}
     * @memberof LocationDtoV3
     */
    deliveryMethods: Array<DeliveryMethodDto>;
    /**
     * 
     * @type {number}
     * @memberof LocationDtoV3
     */
    id: number;
    /**
     * 
     * @type {Array<PlacementDto>}
     * @memberof LocationDtoV3
     */
    placements: Array<PlacementDto>;
    /**
     * 
     * @type {string}
     * @memberof LocationDtoV3
     */
    countryCode: string;
    /**
     * 
     * @type {boolean}
     * @memberof LocationDtoV3
     */
    canUseWastage: boolean;
    /**
     * 
     * @type {Array<OSDiscountDto>}
     * @memberof LocationDtoV3
     */
    discounts: Array<OSDiscountDto>;
    /**
     * 
     * @type {number}
     * @memberof LocationDtoV3
     */
    locationGroupId: number;
    /**
     * 
     * @type {boolean}
     * @memberof LocationDtoV3
     */
    isFoodCourt: boolean;
    /**
     * 
     * @type {Array<PaymentMethodDto>}
     * @memberof LocationDtoV3
     */
    paymentMethods: Array<PaymentMethodDto>;
    /**
     * 
     * @type {boolean}
     * @memberof LocationDtoV3
     */
    isTakeAwayPreselected: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LocationDtoV3
     */
    tableNumberRequiredForDirectSale: boolean;
}

/**
 * Check if a given object implements the LocationDtoV3 interface.
 */
export function instanceOfLocationDtoV3(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "locationId" in value;
    isInstance = isInstance && "zoneId" in value;
    isInstance = isInstance && "currency" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "openingHours" in value;
    isInstance = isInstance && "deliveryMethods" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "placements" in value;
    isInstance = isInstance && "countryCode" in value;
    isInstance = isInstance && "canUseWastage" in value;
    isInstance = isInstance && "discounts" in value;
    isInstance = isInstance && "locationGroupId" in value;
    isInstance = isInstance && "isFoodCourt" in value;
    isInstance = isInstance && "paymentMethods" in value;
    isInstance = isInstance && "isTakeAwayPreselected" in value;
    isInstance = isInstance && "tableNumberRequiredForDirectSale" in value;

    return isInstance;
}

export function LocationDtoV3FromJSON(json: any): LocationDtoV3 {
    return LocationDtoV3FromJSONTyped(json, false);
}

export function LocationDtoV3FromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationDtoV3 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'locationId': json['locationId'],
        'zoneId': json['zoneId'],
        'currency': json['currency'],
        'name': json['name'],
        'openingHours': ((json['openingHours'] as Array<any>).map(OpeningHoursDtoFromJSON)),
        'deliveryMethods': ((json['deliveryMethods'] as Array<any>).map(DeliveryMethodDtoFromJSON)),
        'id': json['id'],
        'placements': ((json['placements'] as Array<any>).map(PlacementDtoFromJSON)),
        'countryCode': json['countryCode'],
        'canUseWastage': json['canUseWastage'],
        'discounts': ((json['discounts'] as Array<any>).map(OSDiscountDtoFromJSON)),
        'locationGroupId': json['locationGroupId'],
        'isFoodCourt': json['isFoodCourt'],
        'paymentMethods': ((json['paymentMethods'] as Array<any>).map(PaymentMethodDtoFromJSON)),
        'isTakeAwayPreselected': json['isTakeAwayPreselected'],
        'tableNumberRequiredForDirectSale': json['tableNumberRequiredForDirectSale'],
    };
}

export function LocationDtoV3ToJSON(value?: LocationDtoV3 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'locationId': value.locationId,
        'zoneId': value.zoneId,
        'currency': value.currency,
        'name': value.name,
        'openingHours': ((value.openingHours as Array<any>).map(OpeningHoursDtoToJSON)),
        'deliveryMethods': ((value.deliveryMethods as Array<any>).map(DeliveryMethodDtoToJSON)),
        'id': value.id,
        'placements': ((value.placements as Array<any>).map(PlacementDtoToJSON)),
        'countryCode': value.countryCode,
        'canUseWastage': value.canUseWastage,
        'discounts': ((value.discounts as Array<any>).map(OSDiscountDtoToJSON)),
        'locationGroupId': value.locationGroupId,
        'isFoodCourt': value.isFoodCourt,
        'paymentMethods': ((value.paymentMethods as Array<any>).map(PaymentMethodDtoToJSON)),
        'isTakeAwayPreselected': value.isTakeAwayPreselected,
        'tableNumberRequiredForDirectSale': value.tableNumberRequiredForDirectSale,
    };
}

